import { client } from "../../../../../Infrastructure/agent";
import { EDBRequestResponse } from "../../../../../shared/EDBRequestResponse";
import { IChangeRequest } from "../types/interface";


export const ChangeRequestService={
    getChangesRequests:():Promise<EDBRequestResponse>=>client.get('/main/getAllChangesRequest'),
    submitChangesRequest:(request:IChangeRequest):Promise<EDBRequestResponse>=>client.post('/main/addChanges',{request}),
    adminApproveRequest:(requestId:number,userId:string,reason:string):Promise<EDBRequestResponse>=>client.post('/main/ApproveChangesRequest',{requestId,userId,reason}),
    supperAdminApproveRequest:(requestId:number,userId:string,reason:string):Promise<EDBRequestResponse>=>client.post('/main/ChangesRequestApproveBySuperAdmin',{requestId,userId,reason}),
    declineRequest:(requestId:number,userId:string,reason:string):Promise<EDBRequestResponse>=>client.post('/main/DeclineChangesRequest',{requestId,userId,reason}),
   
}